import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { publicEnv } from '@/lib/env';

const EditButton = ({ articleSlug }: { articleSlug: string }) => {
  const articleUrl = `${publicEnv.NEXT_PUBLIC_MANAGE_URL}/pickleball/news-content/news/${articleSlug}`;

  return (
    <div
      className='top-6 z-50 flex flex-col items-start justify-center rounded-full hover:bg-gray-100'
      onClick={(e) => e.stopPropagation()}
    >
      <a
        href={`${articleUrl}`}
        className='flex w-full items-center sm:px-3 hover:cursor-pointer mr-3 sm:mr-0'
        aria-label='Edit Article'
      >
        <div className='flex items-center justify-center gap-2'>
          <FontAwesomeIcon icon={faPenToSquare} size='lg' />
          <p className='text-gray-700 text-sm'>Edit article</p>
        </div>
      </a>
    </div>
  );
};

export default EditButton;
